export interface TabConfig {
	label: string;
}

export interface TableColumn {
	key: string;
	label: string;
	sortable?: boolean;
	type?: 'text' | 'date' | 'status' | 'action';
	width?: string;
	align?: 'left' | 'center' | 'right';
}

export interface TableConfig {
	columns: TableColumn[];
	pageSize?: number;
	pageSizeOptions?: number[];
	showPagination?: boolean;
	showSorting?: boolean;
	showActions?: boolean;
	showDateFilters?: boolean;
	showExport?: boolean;
	showRearrange?: boolean;
	allowColumnReorder?: boolean;
}

export interface TableSort {
	active: string;
	direction: SortDirection;
}

export enum SortDirection {
	None = 0,
	Asc = 1,
	Desc = -1
}

export interface TablePageEvent {
	pageIndex: number;
	pageSize: number;
	length: number;
	skip: number;
	take: number;
}
